import IndexPage from '../../components/pages/homes/IndexPage'
export default {
  components: { IndexPage }
}
